import { styled } from "@mui/material/styles";
import { Box, Chip } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: "12px",
}));

export const HeaderRow = styled(Box)(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
}));

export const LeftHeader = styled(Box)(() => ({
    display: "flex",
    gap: "16px",
    alignItems: "center",
}));

export const RightHeader = styled(Box)(() => ({
    display: "flex",
    gap: "8px",
    alignItems: "center",
}));

export const Section = styled(Box)(() => ({
    marginBottom: "20px",
}));

export const StyledChip = styled(Chip)(() => ({
    borderRadius: "8px",
    fontWeight: 500,
    padding: "0 8px",
    color: "black",
}));

export const StatusChip = styled(StyledChip)(() => ({
    background: "#4dd0e1",
}));

export const DangerChip = styled(StyledChip)(() => ({
    background: "#4636f4ff",
}));

export const SystemNoteRow = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginTop: "8px",
}));
